import React from 'react';
import { GraduationCapIcon, AwardIcon, StethoscopeIcon, LeafIcon } from 'lucide-react';
const COACH_PHOTO = 'https://cdn.magicpatterns.com/uploads/6xgB1yXGurLJYx3sbQsL1h/ChatGPT_Image_11_sept_2026,_15_45_35.webp';
const credenciales = [{
  icon: GraduationCapIcon,
  texto: 'Nutricionista Clínica Registrada'
}, {
  icon: AwardIcon,
  texto: 'Máster en Nutrición Antiinflamatoria'
}, {
  icon: StethoscopeIcon,
  texto: 'Especialista en Problemas Digestivos'
}];
const stats = [{
  valor: '12.000+',
  label: 'Mujeres desinflamadas'
}, {
  valor: '15+',
  label: 'Años de experiencia'
}, {
  valor: '4.9/5',
  label: 'Rating promedio'
}, {
  icon: LeafIcon,
  label: 'Especialista en antiinflamatorio'
}];
export function CoachSection() {
  return <section className="w-full bg-gradient-to-b from-mint to-mint-dark px-6 py-20 text-center text-white sm:px-10" data-id="element-38" data-mp="1p9h1urxl1k8x">
      <div className="mx-auto flex max-w-3xl flex-col items-center" data-id="element-39" data-mp="3m4val77zd5u0">
        <img src={COACH_PHOTO} alt="Dra. Marta González, nutricionista clínica registrada" width={180} height={180} loading="lazy" decoding="async" className="h-[160px] w-[160px] rounded-full border-4 border-white object-cover object-center shadow-xl sm:h-[180px] sm:w-[180px]" data-id="element-40" data-mp="3r2587a5iwnsx" />
        <h2 className="mt-6 font-heading text-2xl font-bold sm:text-3xl" data-id="element-41" data-mp="z8qn8u6047r">Dra. Marta González</h2>

        <div className="mt-3 flex flex-col items-center gap-1.5" data-id="element-42" data-mp="yn0qkaklxjj1">
          {credenciales.map(credencial => <p key={credencial.texto} className="flex items-center justify-center gap-1.5 text-sm text-white/90 sm:text-base" data-id="element-43" data-mp="tn4hvy0yt3x5">
              <credencial.icon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-44" data-mp="omqbekf0i218" />
              {credencial.texto}
            </p>)}
        </div>

        <div className="mt-8 max-w-2xl space-y-4 text-[15px] leading-relaxed text-white/95" data-id="element-45" data-mp="39f1vurj1pt9i">
          <p data-id="element-46" data-mp="35d6ytz85e21j">
            Durante 10 años traté a pacientes con hinchazón crónica. Vi que las dietas no funcionaban porque nadie
            personalizaba el plan.
          </p>
          <p data-id="element-47" data-mp="36s9ngt2u83ey">
            Por eso creé este sistema: un método que te enseña a autodiagnosticarte y descubrir qué te funciona a ti,
            sin promesas vacías.
          </p>
          <p className="font-semibold" data-id="element-48" data-mp="2wvoho5izuoa2">Hoy, 12.000+ mujeres ya lo usan. Ayudarte a sentirte mejor es mi pasión.</p>
        </div>

        <div className="mt-10 grid w-full grid-cols-2 gap-4 sm:grid-cols-4 sm:gap-6" data-id="element-49" data-mp="2o3mj6cshji2f">
          {stats.map(stat => <div key={stat.label} className="flex flex-col items-center justify-center rounded-xl bg-white/15 px-3 py-6" data-id="element-50" data-mp="2sul09elask6q">
              {'valor' in stat ? <p className="font-heading text-2xl font-bold" data-id="element-51" data-mp="2e3luebbuk9qu">{stat.valor}</p> : <stat.icon className="h-7 w-7" aria-hidden="true" data-id="element-52" data-mp="2j26wkgant3hx" />}
              <p className="mt-1 text-xs text-white/90 sm:text-sm" data-id="element-53" data-mp="255jxa6v8i18u">{stat.label}</p>
            </div>)}
        </div>
      </div>
    </section>;
}